function videoPlay(self, video) {
    let src = self.parentNode.querySelector(video).getAttribute('data-url'),
        yPlay = `https://www.youtube.com/embed/${src}?rel=0&autoplay=1`;

    self.parentNode.querySelector(video).innerHTML = `
            <iframe
                src="${yPlay}"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>`;
    setTimeout(() => { self.classList.add('playing'); }, 1000);
}

if(document.querySelector('.video-wrapper')) {
    const videoOverlay = document.querySelectorAll('.video-wrapper__overlay');

    videoOverlay.forEach((e) => {
        e.addEventListener('click', function H() {
            let __this = this;
            videoPlay(__this, '.video-wrapper__iframe');
        });
    });
}
